import React from 'react';
import PropTypes from 'prop-types';
import { List, Subheader, Divider, Paper, IconButton } from 'material-ui';
import Loading from '../../common/Loading/Loading';
import Error from '../../common/Error/Error';
import Type from '../Type/Type';
import style from '../../../styles/styles';
import { deleteType, getTypes } from '../../../store/types/actions';
import { connect } from 'react-redux';
import { FlatButton, Dialog } from 'material-ui';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { white } from 'material-ui/styles/colors';
import { Link } from 'react-router-dom';
import withTranslation from '../../../hoc/withTranslation';
import { ADD_TYPE_PAGE } from '../../../constants/routes';

export class SmartTypeList extends React.Component {

    static propTypes = {
        title: PropTypes.string,
    };

    state = {
        typeToRemove: null,
        openRemoveType: false,
        types: [],
    };

    componentWillMount() {
        this.props.getTypes(this.props.app.id, this.props.lang);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            if (this.state.typeToRemove) { // admin has been added
                this.handleCloseType();
            }
        }
        if (this.props.types !== nextProps.types) {
            this.setState({
                types: nextProps.types
                    .sort(function (a, b) {
                        if (a.display_order > b.display_order) {
                            return 1;
                        }
                        if (a.display_order < b.display_order) {
                            return -1;
                        }

                        let aName = a.name !== null ? a.name.trim() : '';
                        let bName = b.name !== null ? b.name.trim() : '';
                        if (aName === bName) {
                            if (a.id > b.id) {
                                return 1;
                            }
                            if (a.id < b.id) {
                                return -1;
                            }
                        }
                        if (aName > bName) {
                            return 1;
                        }
                        if (aName < bName) {
                            return -1;
                        }
                        return 0;
                    }),
            });
        }
    }

    // Delete type

    handleDeleteType = (type) => {
        this.setState({
            openRemoveType: true,
            typeToRemove: type,
        });
    };

    handleCloseType = () => {
        this.setState({
            openRemoveType: false,
            typeToRemove: null,
        });
    };

    deleteType = () => {
        this.props.deleteType(this.props.app.id, this.state.typeToRemove.id);
    };

    // Render

    renderDeleteTypeDialog(type) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseType}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteType}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={this.props.sending}
                open={this.state.openRemoveType}
                onRequestClose={this.handleCloseType}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                    <span>
                        <div
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.props.t(
                                        'settings_page.remove_type_confirmation',
                                        { name: type.name },
                                    ),
                            }}
                        />
                    </span>
                }
            </Dialog>
        );
    }

    render() {
        const {
            loading,
            title,
            user,
            app,
        } = this.props;

        let content;

        if (loading) {
            content = <Loading paper={false} />;
        } else if (this.state.types.length === 0) {
            content =
                <Error
                    title="No data"
                    subtitle="Add some types"
                />;
        } else {
            content = this.state.types.map((type, index) => {
                return (
                    <div key={type.id}>
                        <Type
                            app={app}
                            type={type}
                            user={user}
                            handleRemoveType={this.handleDeleteType}
                        />
                        {index !== (
                            this.state.types.length - 1
                        ) && <Divider inset={true} />}
                    </div>
                );
            });
        }

        return (
            <div>
                {this.state.typeToRemove && this.renderDeleteTypeDialog(this.state.typeToRemove)}
                <Paper>
                    <List>
                        <Subheader style={{ ...style.subHeader, ...style.relative }}>
                            {title}
                            <Link to={ADD_TYPE_PAGE.replace(':appId', this.props.app.id)}>
                                <IconButton
                                    style={style.float.right}
                                    tooltip={this.props.t('settings_page.new_type')}
                                    tooltipPosition="top-center"
                                >
                                    <ContentAdd color={white} />
                                </IconButton>
                            </Link>
                        </Subheader>

                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        app: state.apps.currentApplication,
        user: state.auth.content,
        loading: state.types.pending,
        sending: state.types.sending,
        types: state.types.content,
        lang: state.ui.currentLang,
    };
}

export default connect(mapStateToProps, {
    deleteType,
    getTypes,
})(withTranslation(SmartTypeList));



// WEBPACK FOOTER //
// src/components/type/SmartTypeList/SmartTypeList.js